export default __webpack_public_path__ + "static/media/AfterTitleScreen.5f359cab.mp3";